<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 18 18"
    class="not-sr-only"
    role="img"
    stroke="none"
    fill="currentColor"
  >
    <path
      d="M12.1905 14.4762H1.52381V3.80952H8.38095V2.28571H1.52381C0.685714 2.28571 0 2.97143 0 3.80952V14.4762C0 15.3143 0.685714 16 1.52381 16H12.1905C13.0286 16 13.7143 15.3143 13.7143 14.4762V7.61905H12.1905V14.4762ZM6.25524 12.061L4.7619 10.2629L2.66667 12.9524H11.0476L8.35048 9.36381L6.25524 12.061ZM13.7143 2.28571V0H12.1905V2.28571H9.90476C9.91238 2.29333 9.90476 3.80952 9.90476 3.80952H12.1905V6.08762C12.1981 6.09524 13.7143 6.08762 13.7143 6.08762V3.80952H16V2.28571H13.7143Z"
    ></path>
  </svg>
</template>
